(function () {
  if (window.__ALMIRA_QC_INIT__) return;
  window.__ALMIRA_QC_INIT__ = true;

  if (!window.fetch) return;

  // ----------------------------------------
  // Floating menu (singleton)
  // ----------------------------------------
  var floatEl = document.createElement("div");
  floatEl.className = "almiraQCFloat";
  floatEl.setAttribute("data-qc-float", "");
  floatEl.hidden = true;
  floatEl.innerHTML = '<div class="almiraQCFloat__grid" data-qc-float-grid></div>';
  document.body.appendChild(floatEl);

  var floatGrid = floatEl.querySelector("[data-qc-float-grid]");
  var activeCard = null;
  var activeBtn = null;

  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  function dispatchCartEvents() {
    try { document.dispatchEvent(new CustomEvent("cart:updated")); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent("cart:refresh")); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent("ajaxCart:refresh")); } catch (e) {}
  }

  function closeFloat() {
    floatEl.hidden = true;
    floatEl.style.transform = "translate3d(-9999px,-9999px,0)";
    floatGrid.innerHTML = "";
    activeCard = null;
    activeBtn = null;
  }

  function positionFloatNearButton(btn) {
    if (!rememberOpen()) return;

    floatEl.hidden = false;
    floatEl.style.transform = "translate3d(-9999px,-9999px,0)";

    var br = btn.getBoundingClientRect();
    var fr = floatEl.getBoundingClientRect();

    var left = br.right - fr.width;
    var top = br.top - fr.height - 10;
    if (top < 10) top = br.bottom + 10;

    left = clamp(left, 12, window.innerWidth - fr.width - 12);
    top = clamp(top, 12, window.innerHeight - fr.height - 12);

    floatEl.style.transform = "translate3d(" + left + "px," + top + "px,0)";
  }

  function rememberOpen() {
    // se il menu è stato rimosso/hidden, non posizionare
    return !!(floatEl && floatGrid);
  }

  // ----------------------------------------
  // Cart helpers
  // ----------------------------------------
  function fetchCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function buildQtyMap(cart) {
    var map = {};
    var items = (cart && cart.items) ? cart.items : [];
    for (var i = 0; i < items.length; i++) {
      var id = String(items[i].variant_id);
      map[id] = (map[id] || 0) + (items[i].quantity || 0);
    }
    return map;
  }

  function addToCart(variantId) {
    var fd = new FormData();
    fd.append("id", variantId);
    fd.append("quantity", "1");
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: fd
    }).then(function (res) { return !!res.ok; })
      .catch(function () { return false; });
  }

  function setVariantQty(variantId, qty) {
    var payload = { updates: {} };
    payload.updates[String(variantId)] = qty;

    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Accept": "application/json", "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    }).then(function (res) { return !!res.ok; })
      .catch(function () { return false; });
  }

  // ----------------------------------------
  // Optimistic UI helpers
  // ----------------------------------------
  function getNoVarEls(card) {
    return {
      count: card.querySelector("[data-count]"),
      dec: card.querySelector("[data-dec-direct]"),
      add: card.querySelector("[data-add-direct]")
    };
  }

  function animateChanged(el) {
    if (!el) return;
    el.classList.add("is-changed");
    setTimeout(function () { el.classList.remove("is-changed"); }, 180);
  }

  function optimisticNoVariant(card, delta) {
    var els = getNoVarEls(card);
    if (!els.count || !els.add) return;

    var q = parseInt(els.count.getAttribute("data-qty") || "0", 10) || 0;
    var next = Math.max(0, q + delta);

    els.count.setAttribute("data-qty", String(next));
    if (els.dec) els.dec.setAttribute("data-qty", String(next));

    els.count.textContent = "+" + next;
    els.count.hidden = (next === 0);

    if (els.dec) els.dec.hidden = (next === 0);

    animateChanged(els.count);
  }

  function ensureVariantListVisible(card) {
    var list = card.querySelector("[data-variant-list]");
    if (list) list.hidden = false;
    return list;
  }

  function findChip(card, variantId) {
    return card.querySelector('[data-chip-variant="' + CSS.escape(String(variantId)) + '"]');
  }

  function getChipQty(minusBtn) {
    return parseInt(minusBtn.getAttribute("data-qty") || "0", 10) || 0;
  }

  function optimisticVariantDelta(card, variantId, label, delta) {
    var list = ensureVariantListVisible(card);
    if (!list) return;

    var vid = String(variantId);
    var chip = findChip(card, vid);

    var current = 0;
    if (chip) {
      var minusBtn = chip.querySelector("[data-dec-variant]");
      current = minusBtn ? getChipQty(minusBtn) : 0;
    }

    var next = Math.max(0, current + delta);

    if (next === 0) {
      if (chip) chip.remove();
      if (!list.children.length) list.hidden = true;
      return;
    }

    if (!chip) {
      var div = document.createElement("div");
      div.className = "almiraQC__variantChip";
      div.setAttribute("data-chip-variant", vid);
      div.innerHTML =
        '<button type="button" class="almiraQC__variantChipMinus" data-dec-variant data-variant-id="' + vid + '" data-qty="' + next + '" aria-label="Rimuovi una quantità">−</button>' +
        '<span class="almiraQC__variantChipCount">+' + next + '</span>' +
        '<span class="almiraQC__variantChipLabel">' + (label || "") + "</span>";
      list.prepend(div);
      animateChanged(div);
      return;
    }

    var minusBtn2 = chip.querySelector("[data-dec-variant]");
    var countEl = chip.querySelector(".almiraQC__variantChipCount");
    if (minusBtn2) minusBtn2.setAttribute("data-qty", String(next));
    if (countEl) countEl.textContent = "+" + next;
    animateChanged(chip);
  }

  // ----------------------------------------
  // Sync render from cart
  // ----------------------------------------
  function syncFromCart(cart) {
    var map = buildQtyMap(cart);
    var cards = document.querySelectorAll("[data-almira-qc-card]");

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];

      // no-variants
      var count = card.querySelector("[data-count]");
      var decBtn = card.querySelector("[data-dec-direct]");
      var addBtn = card.querySelector("[data-add-direct]");

      if (count && addBtn) {
        var vid = String(addBtn.getAttribute("data-variant-id") || count.getAttribute("data-variant-id") || "");
        var q = map[vid] || 0;

        count.setAttribute("data-qty", String(q));
        count.textContent = "+" + q;
        count.hidden = (q === 0);

        if (decBtn) {
          decBtn.setAttribute("data-qty", String(q));
          decBtn.hidden = (q === 0);
        }
      }

      // variants chips
      var list = card.querySelector("[data-variant-list]");
      var variants = card.querySelectorAll(".almiraQC__variantData [data-variant]");

      if (list && variants.length) {
        var html = "";
        var any = false;

        for (var j = 0; j < variants.length; j++) {
          var v = variants[j];
          var id = String(v.getAttribute("data-id"));
          var qv = map[id] || 0;
          if (qv > 0) {
            any = true;
            var label = v.getAttribute("data-label") || "";
            html +=
              '<div class="almiraQC__variantChip" data-chip-variant="' + id + '">' +
                '<button type="button" class="almiraQC__variantChipMinus" data-dec-variant data-variant-id="' + id + '" data-qty="' + qv + '" aria-label="Rimuovi una quantità">−</button>' +
                '<span class="almiraQC__variantChipCount">+' + qv + "</span>" +
                '<span class="almiraQC__variantChipLabel">' + label + "</span>" +
              "</div>";
          }
        }

        list.innerHTML = html;
        list.hidden = !any;
      }
    }
  }

  function sync() {
    return fetchCart().then(function (cart) {
      if (cart) syncFromCart(cart);
      return cart;
    });
  }

  // Espone sync per popup correlati
  window.__ALMIRA_QC_SYNC__ = sync;

  // Sync iniziale
  sync();

  // ----------------------------------------
  // Open float for card
  // ----------------------------------------
  function openFloatForCard(card, btn) {
    activeCard = card;
    activeBtn = btn;

    var dataVariants = card.querySelectorAll(".almiraQC__variantData [data-variant]");
    if (!dataVariants.length) return;

    var pills = "";
    for (var i = 0; i < dataVariants.length; i++) {
      var v = dataVariants[i];
      var id = v.getAttribute("data-id");
      var label = v.getAttribute("data-label") || "";
      var available = v.getAttribute("data-available") === "1";
      pills +=
        '<button type="button" class="almiraQCFloat__pill" data-float-variant="' + id + '" data-float-label="' + label + '" ' + (available ? "" : "disabled") + ">" +
          label +
        "</button>";
    }

    floatGrid.innerHTML = pills;
    positionFloatNearButton(btn);
  }

  // ----------------------------------------
  // Click handling (global delegation)
  // ----------------------------------------
  document.addEventListener("click", function (e) {
    // open float
    var open = e.target.closest ? e.target.closest("[data-open-float]") : null;
    if (open) {
      var card = open.closest("[data-almira-qc-card]");
      if (!card) return;

      // toggle
      if (!floatEl.hidden && activeCard === card) {
        closeFloat();
        return;
      }
      openFloatForCard(card, open);
      return;
    }

    // + no-variant
    var addDirect = e.target.closest ? e.target.closest("[data-add-direct]") : null;
    if (addDirect) {
      var card2 = addDirect.closest("[data-almira-qc-card]");
      if (!card2) return;

      optimisticNoVariant(card2, +1);

      addToCart(addDirect.getAttribute("data-variant-id"))
        .then(function (ok) {
          return sync().then(function () {
            if (ok) dispatchCartEvents();
          });
        });

      return;
    }

    // - no-variant
    var decDirect = e.target.closest ? e.target.closest("[data-dec-direct]") : null;
    if (decDirect) {
      var card3 = decDirect.closest("[data-almira-qc-card]");
      if (!card3) return;

      var countEl = card3.querySelector("[data-count]");
      var q = parseInt((countEl && countEl.getAttribute("data-qty")) || "0", 10) || 0;
      if (q <= 0) return;

      optimisticNoVariant(card3, -1);

      var newQty = Math.max(0, q - 1);
      setVariantQty(decDirect.getAttribute("data-variant-id"), newQty)
        .then(function (ok) {
          return sync().then(function () {
            if (ok) dispatchCartEvents();
          });
        });

      return;
    }

    // - on variant chip
    var decVariant = e.target.closest ? e.target.closest("[data-dec-variant]") : null;
    if (decVariant) {
      var card4 = decVariant.closest("[data-almira-qc-card]");
      if (!card4) return;

      var vid = decVariant.getAttribute("data-variant-id");
      var qv = parseInt(decVariant.getAttribute("data-qty") || "0", 10) || 0;
      if (qv <= 0) return;

      var labelEl = decVariant.parentElement ? decVariant.parentElement.querySelector(".almiraQC__variantChipLabel") : null;
      var label = labelEl ? labelEl.textContent : "";

      optimisticVariantDelta(card4, vid, label, -1);

      var newQty2 = Math.max(0, qv - 1);
      setVariantQty(vid, newQty2)
        .then(function (ok) {
          return sync().then(function () {
            if (ok) dispatchCartEvents();
          });
        });

      return;
    }
  });

  // Click su pill del floating menu (varianti)
  floatEl.addEventListener("click", function (e) {
    var pill = e.target.closest ? e.target.closest("[data-float-variant]") : null;
    if (!pill || pill.disabled) return;

    // evita doppi click
    pill.disabled = true;

    var variantId = pill.getAttribute("data-float-variant");
    var label = pill.getAttribute("data-float-label") || "";

    // UI immediata
    if (activeCard) optimisticVariantDelta(activeCard, variantId, label, +1);

    // chiudi subito
    closeFloat();

    addToCart(variantId)
      .then(function (ok) {
        return sync().then(function () {
          if (ok) dispatchCartEvents();
        });
      });
  });

  // Reposition float on resize/scroll
  window.addEventListener("resize", function () {
    if (!floatEl.hidden && activeBtn) positionFloatNearButton(activeBtn);
  });

  window.addEventListener("scroll", function () {
    if (!floatEl.hidden && activeBtn) positionFloatNearButton(activeBtn);
  }, true);

  // Click outside closes float
  document.addEventListener("click", function (e) {
    if (floatEl.hidden) return;
    var insideFloat = e.target.closest ? e.target.closest("[data-qc-float]") : null;
    var openBtn = e.target.closest ? e.target.closest("[data-open-float]") : null;
    if (!insideFloat && !openBtn) closeFloat();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeFloat();
  });
})();

// =======================================================
// DOUBLE TAP TO OPEN PDP (mobile / iPad)
// =======================================================
(function () {
  var TAP_TIMEOUT = 2200; // ms per il secondo tap
  var lastTapEl = null;
  var lastTapTime = 0;

  document.addEventListener("click", function (e) {
    // Solo mobile / iPad
    if (!window.matchMedia || !window.matchMedia("(max-width: 1366px)").matches) return;

    var link = e.target.closest ? e.target.closest(".grid-product__link") : null;
    if (!link) return;

    // Se clicchi su quickcart / correlati / pulsante PDP dedicato → NON interferire
    if (
      e.target.closest(".almiraQC") ||
      e.target.closest(".almiraRelBtn") ||
      e.target.closest(".almiraOpenPdp")
    ) {
      return;
    }

    var now = Date.now();

    // PRIMO TAP
    if (lastTapEl !== link || (now - lastTapTime) > TAP_TIMEOUT) {
      e.preventDefault();
      e.stopPropagation();

      lastTapEl = link;
      lastTapTime = now;

      // feedback visivo leggero
      link.classList.add("almira-first-tap");
      setTimeout(function () {
        link.classList.remove("almira-first-tap");
      }, 300);

      return;
    }

    // SECONDO TAP → lascia aprire la PDP
    lastTapEl = null;
    lastTapTime = 0;
  });
})();

/* =======================================================
   DOUBLE TAP – CORRELATI (pagina prodotto + popup)
   ======================================================= */

(function () {

  var TAP_TIMEOUT = 2200;
  var lastTapEl = null;
  var lastTapTime = 0;

  document.addEventListener("click", function (e) {

    // Solo dispositivi touch
    if (!window.matchMedia || 
        !window.matchMedia("(hover: none) and (pointer: coarse)").matches) {
      return;
    }

    // Link correlati nella pagina prodotto (.crp)
    var crpLink = e.target.closest ? e.target.closest(".crp__imageWrap a") : null;

    // Link correlati nel popup
    var popupLink = e.target.closest ? e.target.closest(".almiraRelModal__item a") : null;

    var link = crpLink || popupLink;
    if (!link) return;

    // NON interferire con quickcart
    if (
      e.target.closest(".almiraQC") ||
      e.target.closest(".almiraRelBtn")
    ) {
      return;
    }

    var now = Date.now();

    // Primo tap
    if (lastTapEl !== link || (now - lastTapTime) > TAP_TIMEOUT) {

      e.preventDefault();
      e.stopPropagation();

      lastTapEl = link;
      lastTapTime = now;

      // micro feedback
      link.classList.add("almira-first-tap");
      setTimeout(function () {
        link.classList.remove("almira-first-tap");
      }, 300);

      return;
    }

    // Secondo tap → lascia navigare
    lastTapEl = null;
    lastTapTime = 0;

  });

})();

